import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'appGender',
  standalone: false
})
export class GenderPipe implements PipeTransform {
  private readonly _locale: string;
  constructor(private readonly translateService: TranslateService) {}

  transform(value?: boolean, locale?: string): string {
    return this.getGender(value, locale);
  }

  private getGender(value?: boolean, locale?: string): string {
    if (value === null || value === undefined || !locale) {
      return '';
    }
    return value
      ? this.translateService.instant('i18n.common.frauen')
      : this.translateService.instant('i18n.common.maenner');
  }
}
